import { LinkButton, SubsectionGroup } from '@sleepstation/components'
import { BreakingLayout, VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import {
  DIRECTION,
  LAYOUT_ALIGN,
  LAYOUT_CHILD,
  LAYOUT_JUSTIFY,
  LAYOUT_SPACING,
} from '@sleepstation/const'
import { parseHtmlToAst } from '@sleepstation/markdown'
import { mq } from '@sleepstation/style-api-helpers'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(BreakingLayout).attrs({
  spacing: [LAYOUT_SPACING.XX_LARGE, LAYOUT_SPACING.XX_LARGE, 4],
  direction: [DIRECTION.VERTICAL, DIRECTION.HORIZONTAL],
  child: LAYOUT_CHILD.EQUAL,
  align: [LAYOUT_ALIGN.STRETCH, LAYOUT_ALIGN.TOP],
  justify: LAYOUT_JUSTIFY.CENTER,
})`
  ${mq(`mediumUp`)} {
    > * {
      max-width: 55%;
    }
  }
`

const CtaBody = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
})`
  > a {
    max-width: ${rem(374)};
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SecondaryCtas = ({ secondaryCtas, showDownload }) => {
  const { questions, download } = secondaryCtas
  const { link } = download
  const questionsAst = parseHtmlToAst(`<p>${questions.body}</p>`)

  return (
    <Layout>
      {showDownload && (
        <SubsectionGroup title={download.title}>
          <CtaBody>
            <CopyRenderer htmlAst={parseHtmlToAst(download.body)} />
            <ThemeProvider theme={defaultAltTheme}>
              <LinkButton
                kind="secondary"
                icon={link.icon}
                href={link.url}
                iconIsLast
              >
                {link.label}
              </LinkButton>
            </ThemeProvider>
          </CtaBody>
        </SubsectionGroup>
      )}
      <SubsectionGroup title={questions.title}>
        <CopyRenderer htmlAst={questionsAst} />
      </SubsectionGroup>
    </Layout>
  )
}

SecondaryCtas.propTypes = {
  secondaryCtas: PropTypes.object.isRequired,
  showDownload: PropTypes.bool.isRequired,
}

export default SecondaryCtas
